// extracted by mini-css-extract-plugin
export var lg = "_4o-4";
export var md = "_4o-3";
export var sm = "_4o-2";
export var xs = "_4o-1";
export var xxs = "_4o-0";